import liveChatWidgetSub from './liveChatWidgetSub';
import React from 'react';

import { applyCdnUrl } from '../utils/site-utils';

export default class LiveChatWidgetSub extends React.Component {
	onAction = () => {
		this.props.onAction();
	}

	
	renderAction(eleSet) {
		return (
			<li>
				<a href="#" onClick={this.onAction}>
					<img src={applyCdnUrl(`/${eleSet.ImgSrc}`)} alt="" />
				</a>
			</li>
		);
	}
	
	renderLink(eleSet) {
		return (
			<li>
				<a href={eleSet.Target} target="_blank">
					<img src={applyCdnUrl(`/${eleSet.ImgSrc}`)} alt="" />
				</a>
			</li>
		);
	}

	renderNoLink(eleSet) {
		return (
			<li>
				<img src={applyCdnUrl(`/${eleSet.ImgSrc}`)} alt="" />
			</li>
		);
	}
	
	renderHoverLink(eleSet) {
		const targetText = eleSet.Target.split('\n').map((item, i) => (
			<span key={i}>
				{item}
				<br />
			</span>
		));
		return (
			<li>
				<a href="javascript:void(0);">
					<img src={applyCdnUrl(`/${eleSet.ImgSrc}`)} alt="" />
				</a>
				<div className="tip">{targetText}</div>
			</li>
		);
	}
	
	render() {
		const eleSet = this.props.elementSet;
		// var _self = this;

		switch (eleSet.ActionType) {
			case '0':
				return this.renderNoLink(eleSet);
			case '1':
				return this.renderLink(eleSet);
			case '2':
				return this.renderAction(eleSet);
			case '3':
				return this.renderHoverLink(eleSet);
			default:
				return false;
		}
	}
}
